import { pipe } from 'ramda';
import { Category } from 'api/timesheets/categories';
import { Deleting } from 'core/state';
import { from } from './core';

export const asMasterList = pipe(from, ({ ids, byId }) =>
  (ids[1] ?? [])
    .map((x) => byId[x])
    .filter(Boolean)
    .filter((x) => x[0] !== 'deleting')
    .map((x) => x as Exclude<typeof x, Deleting<Category>>),
);
export const asList = pipe(asMasterList, (list) =>
  list.filter((x) => !x[1].deleted),
);
export const hasData = pipe(from, ({ ids }) => ids[0] === 'just');
